import { MapType } from 'features/maps/types'
import { IntersectAndAggregateSettingsQueryParams } from '../types'
import { getQFromQuery, buildAnalysisQueryFromSource, increaseQueriesNumber, isAnalysis } from '../../utils'

export const generateQuery = ({
  columns,
  baseGeometryColumn,
  secondGeometryColumn,
  operation,
  base,
  second,
  resultColumnName
}: IntersectAndAggregateSettingsQueryParams) => {
  const qBase = buildAnalysisQueryFromSource({ source: base })
  let qSecond = buildAnalysisQueryFromSource({ source: second, wrapWith: false, lastQNumber: getQFromQuery(qBase) })
  const isSecondAnalysis = second?.type === MapType.query && isAnalysis(second?.source)
  if (isSecondAnalysis) {
    const lastQNumber = getQFromQuery(qBase)
    qSecond = qSecond.replace(/WITH __q1 AS \(/, '__q1 AS (')
    qSecond = increaseQueriesNumber(qSecond, lastQNumber)
  }
  const qBaseNumber = getQFromQuery(qBase) || 1
  const qSecondNumber = getQFromQuery(qSecond) || 2
  const nextQNumber = qSecondNumber + 1
  const columnsStr = columns.length ? `\n${columns.map((c) => `\t\t${c}`).join(',\n')},` : ''
  const groupStr = columns.length ? `\n\tGROUP BY\n\t\t${columns.map((_, i) => i + 1).join(',')}` : ''
  const query = `${qBase},\n${qSecond},
__q${nextQNumber} AS (
\tSELECT${columnsStr}
\t\tANY_VALUE(base.${baseGeometryColumn}) AS geom,
\t\t${operation} AS ${resultColumnName}
\tFROM
\t\t__q${qBaseNumber} AS base,
\t\t__q${qSecondNumber} AS second
\tWHERE
\t\tST_INTERSECTS(ST_SetSRID(base.${baseGeometryColumn}, 4326), ST_SetSRID(second.${secondGeometryColumn}, 4326))${groupStr}
)
SELECT * FROM __q${nextQNumber}`
  return query
}
